import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab, { EfSwiperTabItemProps, EfSwiperTabProps } from '@elem/ui/ef-swiper-tab';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const lists: EfSwiperTabItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724920729196/pc_app%20control_01.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724920729196/pc_app%20control_01.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724920785210/m_app%20control_01.jpg',
            tab: t('L_tab1'),
            desc: t('L_tab1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724920729375/pc_app%20control_02.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724920729375/pc_app%20control_02.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724920785384/m_app%20control_02.jpg',
            tab: t('L_tab2'),
            desc: t('L_tab2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724920729522/pc_app%20control_03.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1724920729522/pc_app%20control_03.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724920785569/m_app%20control_03.jpg',
            tab: t('L_tab3'),
            desc: t('L_tab3_desc'),
        },
    ];

    const configs: EfSwiperTabProps = {
        theme: 'white',
        gap: 0,
        lists,
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSwiperTab {...configs} />
        </div>
    );
}
